/**
 * Stack routes of the native screens added by the `users` admin-module group.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'UsersDetailScreen', component: lazyScreen(() => import('../../screens/adminModules/users/UsersDetailScreen'))},
];

export default ROUTES;
